import { MsMinus as c, MsPlus as m } from "@sunrise/icons";
import { hashCodeOf as l } from "@sunrise/shared";
import { track as s } from "@sunrise/tracking";
import { defineComponent as u, ref as d } from "vue";
const y = u({
  name: "CsAccordion",
  components: {
    MsPlus: m,
    MsMinus: c
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    isInitiallyOpen: Boolean,
    hasBorder: Boolean,
    id: String,
    trackingData: {
      default: null,
      type: Object
    }
  },
  setup(t) {
    const r = d(t.id || l(t.label));
    function n(e) {
      return e ? "mehr" : "weniger";
    }
    function a(e) {
      if (!t.trackingData)
        return;
      const i = e.target, o = {
        ...t.trackingData,
        mslayer_element_type_text: n(i.checked)
      };
      s(o);
    }
    return {
      computedId: r,
      trackClick: a,
      determineTypeText: n
    };
  }
});
export {
  y as default
};
